

export class PlanRoute{
    constructor(site){
        var _site = site,
            _from,
            _to,
            _fromLat,
            _fromLon,
            _toLat,
            _toLon,
            _date,
            _time,
            _deparr,
            _wheelchairAccess
        ;

        /* ====================================== */
        /* PUBLIC                                 */ 
        /* ====================================== */

        Object.defineProperty(this,'site',{
            set: function(s){ _site = s },
            get : function(){ return _site }
        });

        Object.defineProperty(this,'from',{
            set: function(f){ _from = f },
            get : function(){ return _from }
        });

        Object.defineProperty(this,'to',{
            set: function(t){ _to = t },
            get : function(){ return _to }
        })

        Object.defineProperty(this,'fromLat',{
            set: function(f){ _fromLat = f },
            get : function(){ return _fromLat }
        })

        Object.defineProperty(this,'fromLon',{
            set: function(f){ _fromLon = f },
            get : function(){ return _fromLon }
        })

        Object.defineProperty(this,'toLat',{
            set: function(t){ _toLat = t },
            get : function(){ return _toLat }
        })

        Object.defineProperty(this,'toLon',{
            set: function(t){ _toLon = t },
            get : function(){ return _toLon }
        });

        Object.defineProperty(this,'date',{
            set: function(d){ _date = d },
            get : function(){ return _date }
        })

        Object.defineProperty(this,'time',{
            set: function(t){ _time = t },
            get : function(){ return _time }
        })

        Object.defineProperty(this,'deparr',{
            set: function(d){ _deparr = d },
            get : function(){ return _deparr }
        })

        Object.defineProperty(this,'wheelchairAccess',{
            set: function(w){ _wheelchairAccess = w },
            get : function(){ return _wheelchairAccess }
        })

        // ==========
        // private
        // ----------        
    }

    /*
    initPlanRoute(planRouteOptions){
        Object.assign(this,planRouteOptions);
    }
    */

    // ==========
    // public 
    // ----------
    buildUrl(){ // use buildurl instead 
        var url = `https://app.mecatran.com/utw/ws/planroute/${this.site}?`;
        url += `from=${this.from}&to=${this.to}&fromLat=${this.fromLat}&fromLon=${this.fromLon}&toLat=${this.toLat}&toLon=${this.toLon}&date=${this.date}&time=${this.time}&deparr=${this.deparr}&wheelchairAccess=${this._wheelchairAccess}`;
        return url; 
    }
    
    plan(){
        var url = this.buildUrl();
        window.open(url);
    }
}

/*
https://app.mecatran.com/utw/ws/planroute/pdl?from=Adresse+de+d%C3%A9part&to=Arriv%C3%A9e&fromLat=47.218&fromLon=-1.604&toLat=47.223&toLon=-1.533&date=2021-05-21&time=16:20&deparr=arr&wheelchairAccess=false
*/

/*
PlanRoute Options interface
==========================
site
from
to
fromLat
fromLon
toLat
toLon
date
time
deparr
wheelchairAccess
*/